import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_COUNTRY_THEMES_LOG: TDatadogErrorLog = {
  from: 'modules/global-topic/theme-list-tab',
  name: 'Gets the global taxonomy themes',
  message: 'Failed to fetch the global taxonomy themes of the workspace country',
}
